var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ui-tooltip-wrapper",class:{ 'is-inline': _vm.inline }},[_c('div',{staticClass:"ui-tooltip-active-area"},[_vm._t("active")],2),_vm._v(" "),_c('div',{ref:"popup",staticClass:"ui-tooltip-popup"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }